/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const RightAlign = styled.div`
  display : flex;
  justify-content : flex-end;
`;
